export var every = function (obj, cb) {
    if (obj && obj.getEnumerator) {
        var enumerator = obj.getEnumerator();
        var index = 0;
        if (enumerator.moveNext && enumerator.get_current) {
            var keepOnRunning = null;
            while (enumerator.moveNext() && keepOnRunning !== false) {
                keepOnRunning = cb(enumerator.get_current(), index++);
            }
        }
    }
};
export var lookFor = function (obj, cb) {
    if (obj && obj.getEnumerator) {
        var enumerator = obj.getEnumerator();
        if (enumerator.moveNext && enumerator.get_current) {
            while (enumerator.moveNext()) {
                if (cb(enumerator.get_current())) {
                    return enumerator.get_current();
                }
            }
        }
    }
};
export var filterFor = function (obj, cb) {
    var result = [];
    if (obj && obj.getEnumerator) {
        var enumerator = obj.getEnumerator();
        if (enumerator.moveNext && enumerator.get_current) {
            while (enumerator.moveNext()) {
                if (cb(enumerator.get_current())) {
                    result.push(enumerator.get_current());
                }
            }
        }
    }
    return result;
};
